
<template>
  <div>
    <v-dialog v-model="dialog" transition="dialog-bottom-transition" scrollable >
      <v-card v-if="dialog">
        <v-card-title primary-title class="pa-0">
          <v-toolbar dark color="primary" >
            <v-toolbar-title>Editar Colaborador</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="$emit('closeEditEmployee')" dark>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text v-if="edit_employee" class="pt-3 pb-0">
          <v-text-field label="Nome" v-model="edit_employee.name" :rules="required"></v-text-field>
          <v-checkbox label="Terceirizado" v-model="edit_employee.outsourced"></v-checkbox>
          <v-text-field label="Nome da empresa" v-model="edit_employee.company_name" :rules="required"></v-text-field>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn color="success" @click="editEmployee()"><v-icon left>mdi-check</v-icon>Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import validations from '@/mixins/validations';

export default {
  name: 'DialogEditEmployee',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    employee: {
      type: Object
    }
  },
  mixins: [
    validations
  ],
  data() {
    return {
      edit_employee: null,
      loading_saving: false
    }
  },
  mounted () {
    this.edit_employee = {...this.employee};
  },
  methods: {
    editEmployee() {
      this.loading_saving = true;
      this.updateEmployee({...this.edit_employee}).then(() => {
        this.loading_saving = false;
        this.$emit('closeEditEmployee');
      })
    },
    ...mapActions({
      updateEmployee: 'Execution/updateEmployee'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>